import { ProfileHonorRecordModel } from '@vp/profile/core/model/ProfileHonorRecordModel';

export abstract class HonorManagerRepository {
  abstract getHonorRecords(id: string, controller?: AbortController): Promise<ProfileHonorRecordModel[]>;
  abstract removeHonorRecords(ids: string[], profileId: string, controller?: AbortController): Promise<void>;
  abstract approveHonorRecords(ids: string[], profileId: string, controller?: AbortController): Promise<ProfileHonorRecordModel[]>;
  abstract editHonorRecord(id: string, newText: string, controller?: AbortController): Promise<ProfileHonorRecordModel>;
}
